import { render, staticRenderFns } from "./customer-filter.vue?vue&type=template&id=1690a64f&scoped=true"
import script from "./customer-filter.vue?vue&type=script&lang=ts"
export * from "./customer-filter.vue?vue&type=script&lang=ts"
import style0 from "./customer-filter.vue?vue&type=style&index=0&id=1690a64f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1690a64f",
  null
  
)

export default component.exports